import { render, staticRenderFns } from "./FlashSale.vue?vue&type=template&id=2f064bfe&scoped=true"
import script from "./FlashSale.vue?vue&type=script&lang=js"
export * from "./FlashSale.vue?vue&type=script&lang=js"
import style0 from "./FlashSale.vue?vue&type=style&index=0&id=2f064bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f064bfe",
  null
  
)

export default component.exports